module.exports = __webpack_public_path__ + "6240fd81.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/presentation/Details/appleBadge.png
// module id = 2778
// module chunks = 15